
export const moduleSettings = {
  code: 'schedules',
  name: 'schedules',
  hasAccessControl: false,
  hasSettings: false,
};
